import { Fragment } from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import {
  FirstSection,
  SecondSection,
  ThirdSection,
  FourthSection,
  FifthSection,
  SixthSection,
  SeventhSection,
  EighthSection,
} from '~partials/product/Sections'

const ProductOverview = () => {
  const {
    file: {
      childMdx: { frontmatter: pageData },
    },
  } = useStaticQuery(graphql`
    query ProductOverviewPageData {
      file(name: { eq: "product" }, absolutePath: { regex: "/src/data/" }) {
        childMdx {
          frontmatter {
            newApproach {
              heading
              blurb
            }
            animatedFeatures {
              heading
              subHeading
              pointers {
                pointer
              }
              animationPointer
            }
            trialSection {
              heading
              buttonText
              buttonURL
              extraText
            }
            howItWorks {
              heading
              subHeading
              blurb
              buttonURL
              buttonText
            }
            useCases {
              heading
              subHeading
              cases {
                heading
                icon
              }
            }
            featureHighlights {
              heading
              subHeading
              features {
                heading
                blurb
                icon
              }
            }
            supportedPlatforms {
              heading
              subHeading
              blurb
            }
            productSecurity {
              heading
              blurb
              buttonText
              items {
                heading
                blurb
                icon
              }
            }
          }
        }
      }
    }
  `)

  return (
    <Fragment>
      <FirstSection data={pageData.newApproach} />
      <SecondSection data={pageData.animatedFeatures} />
      <ThirdSection data={pageData.trialSection} />
      <FourthSection data={pageData.howItWorks} />
      <FifthSection data={pageData.featureHighlights} />
      <SixthSection data={pageData.useCases} />
      <SeventhSection data={pageData.supportedPlatforms} />
      <EighthSection data={pageData.productSecurity} />
    </Fragment>
  )
}

export default ProductOverview
